import { DimensionFilterOp } from "@gen/tracker/v1/reporting_pb";

import type { ReportFilters } from "@/lib/report";

/**
 * Narrowing a report to one value of a dimension: the card's «в Отчётах» and
 * a tap on a row of the phone's report (доска MReport) — an ordinary report
 * filter (`flt`), so the desktop opens the same slice. Pure.
 */

/** Narrow `filters` to `dim = value` (replacing an earlier pick of the same dimension). */
export function narrow(filters: ReportFilters, dim: string, value: string): ReportFilters {
  return {
    dims: [...filters.dims.filter((d) => d.key !== dim), { key: dim, op: DimensionFilterOp.IN, values: [value] }],
    metrics: filters.metrics,
  };
}
